module.exports = __webpack_public_path__ + "img/brand-2.815350b6.png";